import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Section from 'components/Section';
import TextField from '@mui/material/TextField';
import TwoColumn from 'components/TwoColumn';

import { OrderEditMainAccomodation_order$key } from '__generated__/OrderEditMainAccomodation_order.graphql';

type Props = {
  order: OrderEditMainAccomodation_order$key;
};

const OrderEditMainAccomodation: FC<Props> = ({ order }) => {
  const { hotelName, hotelStars } = useFragment(
    graphql`
      fragment OrderEditMainAccomodation_order on Order {
        hotelName
        hotelStars
      }
    `,
    order
  );

  return (
    <Section title="Nakvynė" id="accomodation">
      <TwoColumn
        left={
          <TextField
            fullWidth
            disabled
            label="Viešbutis"
            variant="standard"
            value={hotelName}
          />
        }
        right={
          <TextField
            fullWidth
            disabled
            label="Žvaigždutės"
            variant="standard"
            value={hotelStars}
          />
        }
      />
    </Section>
  );
};

export default OrderEditMainAccomodation;
